import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { StringMatchChip } from '../StringMatchChip/StringMatchChip';
export const GetClientNameChipTID = (parentTestId)=>getTestIds(parentTestId);
export const ClientNameChip = (param)=>{
    let { testId, predicate, onChange } = param;
    const { ClientNameChipTestIds } = useMemo(()=>GetClientNameChipTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    return /*#__PURE__*/ _jsx(StringMatchChip, {
        testId: testId,
        predicate: predicate,
        onChange: onChange,
        labels: {
            contains: (value)=>t.clientNameContains({
                    value
                }),
            fuzzy: (value)=>t.clientNameFuzzy({
                    value
                }),
            exact: (value)=>t.clientNameExact({
                    value
                }),
            startsWith: (value)=>t.clientNameStartsWith({
                    value
                }),
            empty: ()=>t.clientNameLabel()
        },
        biNames: {
            edit: 'drafts_ai_search_chip_edit_client_name',
            apply: 'drafts_ai_search_chip_apply_client_name',
            remove: 'drafts_ai_search_chip_remove_client_name'
        },
        popoverTestIds: {
            EditPopover: ClientNameChipTestIds.EditPopover(),
            EditTextField: ClientNameChipTestIds.EditTextField(),
            ApplyButton: ClientNameChipTestIds.ApplyButton()
        }
    });
};
